import {MithrilComponent} from '@bitstillery/mithril'
import {Button} from '@bitstillery/common/components'
import {classes, merge_deep} from '@bitstillery/common/lib/utils'
import {$s, $t} from '@bitstillery/common/app'
import m from '@bitstillery/mithril'
import {ContextProvider} from '@bitstillery/common/lib/context'
import type {ContextProviderDataGeneric} from '@bitstillery/common/lib/context'

export interface DataCardAttrs {
    className?: string
    model: {
        /** Falsy entries are skipped, so `cond && {...}` works inline. */
        data: (DataCardEntry | null | undefined | false | 0)[]
    }
    type?: string
    variant?: string
}

export interface DataCardEntry {
    label: string | JSX.Element
    value?: m.Children
    hide_value?: boolean
    type?: string
}

export interface DataCardModel {
    data: (DataCardEntry | null)[]
}

export class DataCard extends MithrilComponent<DataCardAttrs> {
    view(vn: m.Vnode<DataCardAttrs>) {
        return (
            <div
                className={classes(
                    'c-data-card',
                    `type-${vn.attrs.type ? vn.attrs.type : 'default'}`,
                    vn.attrs.className,
                    `variant-${vn.attrs.variant ? vn.attrs.variant : 'default'}`,
                )}
            >
                {vn.attrs.model.data.map((entry: DataCardEntry | null | undefined | false | 0) => {
                    if (!entry) return null
                    return (
                        <div className={classes('entry', `type-${entry.type ? entry.type : 'default'}`)}>
                            <div className='entry-label'>{entry.label}</div>
                            {!entry.hide_value && <div className='entry-value'>{entry.value ? entry.value : '-'}</div>}
                        </div>
                    )
                })}
            </div>
        )
    }
}

export interface ButtonDataCardAttrs {
    context?: ContextProvider<ContextProviderDataGeneric>
    fetch_entity?: string
}

export class ButtonDataCard extends MithrilComponent<ButtonDataCardAttrs> {
    view(vnode: m.Vnode<ButtonDataCardAttrs>) {
        return (
            <Button
                active={(() => {
                    if (vnode.attrs.context) {
                        return vnode.attrs.context.link_entity_active('data_card')
                    }
                    return !$s.panels.context.collapsed
                })()}
                className='btn-data-card'
                icon='card_account_details_outline'
                link={
                    vnode.attrs.context
                        ? vnode.attrs.context.link_entity(
                              'data_card',
                              vnode.attrs.context.data.entity_type === 'data_card'
                                  ? vnode.attrs.context.data.entity_artkey
                                  : vnode.attrs.fetch_entity,
                          )
                        : undefined
                }
                onclick={() => {
                    if (vnode.attrs.context) {
                        merge_deep(vnode.attrs.context.data, {entity_artkey: null})
                        return
                    }
                    $s.panels.context.collapsed = !$s.panels.context.collapsed
                }}
                replace_history={!!vnode.attrs.context}
                tip={$t('data_card.tip')}
                text={$t('data_card.text')}
                type='info'
                variant='context'
            />
        )
    }
}
